import { useState } from "react";
import * as _ from "@antv/util";
import useDetectImage from "../../functions/Image/detectImage";
import UploadImageFunc from "./UploadImageFunc";
import { Typography, Flex } from "antd";

const timeout_duration = 10;

export default function UpdateImageTab(props) {
  const {
    plates,
    setPlates,
    selectedPlateIndex,
    setIsDisableButton,
    activeTabKey,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [loadingTip, setLoadingTip] = useState();

  const { detectImage } = useDetectImage();

  const getPlates = (cloned_plates) => {
    setPlates(cloned_plates);
    setIsDisableButton((prev) =>
      Object.fromEntries(Object.keys(prev).map((key) => [key, false]))
    );
  };

  function onConfirmImage(capturedImage) {
    detectImage(
      capturedImage,
      timeout_duration,
      plates,
      selectedPlateIndex,
      getPlates,
      setIsLoading,
      setLoadingTip
    );
  }

  return (
    <Flex
      vertical="vertical"
      gap="small"
      style={{ height: "100%", width: "100%" }}
    >
      <div className="image-container">
        {plates[selectedPlateIndex]?.ai_image_data == null ? (
          <UploadImageFunc
            content={
              <span>
                Select an image to upload
                <br />
                Mixed Rice Image
              </span>
            }
            shape={"circle"}
            isLoading={isLoading}
            loadingTip={loadingTip}
            onConfirmImage={onConfirmImage}
            onRejectImage={() => {}}
            activeTabKey={activeTabKey}
          />
        ) : (
          <div className="preview-container">
            <img
              src={plates[selectedPlateIndex]?.ai_image_data}
              alt="Selected Plate"
              className="preview-image"
              style={{ objectFit: "contain" }}
            />
          </div>
        )}
      </div>
    </Flex>
  );
}
